<h2 mat-dialog-title>
  {{ 'PRODUCT.USERADMIN.PRIVACY_POLICY.TITLE' | translate }}
</h2>
<mat-dialog-content style="width: 900px">
  <p>{{ 'PRODUCT.USERADMIN.PRIVACY_POLICY.TEXT1' | translate }}</p>
  <p>{{ 'PRODUCT.USERADMIN.PRIVACY_POLICY.TEXT2' | translate }}</p>
  <p>
    <mat-checkbox #agree>
      {{ 'PRODUCT.USERADMIN.PRIVACY_POLICY.TEXT3' | translate }}
      <a
        href="https://www.einsatzwetter.de/datenschutzerklaerung/"
        target="_blank"
        >{{ 'PRODUCT.USERADMIN.PRIVACY_POLICY.TEXT4' | translate }}</a
      >
      {{ 'PRODUCT.USERADMIN.PRIVACY_POLICY.TEXT5' | translate }}
    </mat-checkbox>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button class="btn-app-cancel" mat-dialog-close>
    Nein
  </button>
  <button
    [disabled]="!agree.checked"
    mat-raised-button
    class="btn-app-save"
    [mat-dialog-close]="true"
    cdkFocusInitial>
    Ja
  </button>
</mat-dialog-actions>
